/**
 * Environment-derived flags for the frontend.
 *
 * The values themselves, and the checks that they are the right values for the
 * environment claimed, live in config/env.ts. This file only re-exports them and
 * adds the reCAPTCHA key selection on top, so that the 15-odd modules already
 * importing from here keep working unchanged.
 */
import { logger } from "@/lib/logger";
import { IsDevelopment, IsProduction, IsStaging, PUBLIC_ENV } from "./env";

export { PUBLIC_ENV, IsStaging, IsProduction, IsDevelopment };

export const RECAPTCHA_SITE_KEY = (() => {
  if (IsProduction) return process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? "6LfCg4EsAAAAAL4sWQG2QWxtjMccpLJU--Pn6UeZ";
  if (IsStaging) return process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY_STAGING ?? "6LdIgYEsAAAAABi1NYOcB-yFjzMedl1eDr-R4rCQ";
  if (IsDevelopment)
    // [Reference]: https://developers.google.com/recaptcha/docs/faq
    return process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY_LOCAL ?? "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

  logger.warn(
    "[config] Unknown environment. Using staging site key as fallback."
  );
  return process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY_LOCAL ?? "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
})();
